<template>
  <div class="Login">
    <div class="tit_img">
      <img src="../../assets/image/home/logo_w.png" alt="" />
    </div>
    <el-card class="box_card">
      <el-row class="flex-col-center">
        <el-col :span="12">
          <p class="tit">个人用户登录</p>
        </el-col>
        <el-col :span="12">
          <p class="text-right">
            还没有账号?<a @click="link('MRegister')">点击注册</a>
          </p>
        </el-col>
      </el-row>
      <div class="form">
        <el-form
          ref="ruleform"
          :model="form"
          :rules="rules"
          label-width="80px"
          label-position="top"
        >
          <el-form-item label="手机号:" prop="mobile">
            <el-input
              v-model="form.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
              @keyup.enter.native="login('ruleform')"
            ></el-input>
          </el-form-item>
          <el-form-item class="btn">
            <el-button type="primary" @click="login('ruleform')"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <p>忘记密码?<a @click="link('MReset')">点击重置</a></p>
    </el-card>
  </div>
</template>
<script>
let _this
export default {
  data() {
    var validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        if (/^1[3456789]\d{9}$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      form: { mobile: '', password: '' },
      rules: {
        mobile: {
          required: true,
          validator: validateMobile,
          message: '请输入手机号',
          trigger: ['blur', 'change'],
        },

        password: {
          required: true,
          message: '请输入密码',
          trigger: 'blur',
        },
      },
      loading: false,
    }
  },
  created() {
    _this = this
    this.init()
  },
  methods: {
    init() {},
    link(name) {
      this.$router.push({ name: name })
    },

    login(formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          _this.loading = true
          _this.$http
            .post(process.env.VUE_APP_URL + 'login', this.form)
            .then(data => {
              _this.loading = false
              if (data.data.code == 200) {
                _this.Storage.setStorage('token', data.data.token)
                _this.$store.commit('setUser', data.data.data)
                _this.$router.push({ path: '/home' })
              } else {
                _this.$message.error(data.data.msg)
              }
            })
            .catch(err => {
              _this.$message.error('网络错误，请重试')
              console.log(err)
              _this.loading = false
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.Login {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0px;
  background: linear-gradient(to right, #ff9b5f 0%, #ff7a54 100%);
  padding-top: 20vh;
  .tit_img {
    margin: 20px auto;
    width: 60vw;
    img {
      width: 100%;
    }
  }
  .box_card {
    width: 80vw;
    margin: 0px auto;
    p {
      font-size: 10px;
      a {
        color: #6f8bff;
      }
    }
    .tit {
      font-weight: 800;
      font-size: 18px;
    }
  }
  .form {
    padding: 20px 20px 0px;
    /deep/.el-form-item__label {
      line-height: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      font-size: 14px;
    }
    .el-form-item {
      margin-bottom: 15px !important;
    }
    .btn {
      text-align: center;
      .el-button {
        width: 153px;
        height: 40px;
        background: #fd4a29;
        border-radius: 4px;
        border: none;
      }
    }
    /deep/.el-form-item__error {
      position: relative;
    }
  }
}
</style>
